module.exports = __webpack_public_path__ + "img/ferie_top.9d1bf8bb.png";